import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// DragOverlay.tsx -- full-screen drop indicator while a native (OS) file
// drag is over the desktop.
//
// Per design \u00a76.5: when a native drag enters the window we highlight
// either a specific folder icon (handled in DesktopIcon's onDragEnter) or
// the whole canvas (this component). The mounted instance listens on window
// for native dragenter / dragleave / drop to show/hide a translucent
// "Drop to upload to <folder>" panel.
//
// The actual upload kickoff happens in Desktop.tsx's onDrop -- this
// component is purely visual feedback.
import { useEffect, useState } from 'react';
export function DragOverlay({ folderName }) {
    const [visible, setVisible] = useState(false);
    const [counter, setCounter] = useState(0); // dragenter / dragleave reference count
    useEffect(() => {
        const onEnter = (e) => {
            if (!e.dataTransfer || !Array.from(e.dataTransfer.types).includes('Files'))
                return;
            setCounter((c) => c + 1);
            setVisible(true);
        };
        const onOver = (e) => {
            if (!e.dataTransfer || !Array.from(e.dataTransfer.types).includes('Files'))
                return;
            e.preventDefault();
        };
        const onLeave = (e) => {
            if (!e.dataTransfer || !Array.from(e.dataTransfer.types).includes('Files'))
                return;
            setCounter((c) => {
                const n = Math.max(0, c - 1);
                if (n === 0)
                    setVisible(false);
                return n;
            });
        };
        const onDrop = () => {
            setCounter(0);
            setVisible(false);
        };
        window.addEventListener('dragenter', onEnter);
        window.addEventListener('dragover', onOver);
        window.addEventListener('dragleave', onLeave);
        window.addEventListener('drop', onDrop);
        return () => {
            window.removeEventListener('dragenter', onEnter);
            window.removeEventListener('dragover', onOver);
            window.removeEventListener('dragleave', onLeave);
            window.removeEventListener('drop', onDrop);
        };
    }, []);
    if (!visible)
        return null;
    return (_jsx("div", { className: "drag-overlay", "aria-hidden": true, children: _jsxs("div", { className: "drag-overlay-panel", children: [_jsx("div", { className: "drag-overlay-glyph", children: '\u2B07\uFE0F' }), _jsxs("div", { className: "drag-overlay-text", children: ["Drop files to upload to ", _jsx("strong", { children: folderName })] }), _jsx("div", { className: "drag-overlay-hint", children: "Drop directly on a folder icon to upload there instead" })] }) }));
}
